import {emptySplitApi, providesTagsList, queryStarted} from "./api";

export const companiesApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        listCompanies: builder.query({
            query: (credentials) => ({
                url: 'company/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('Company', result)
        }),
        listCompanyAccounts: builder.query({
            query: () => ({
                url: 'company/users/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('CompanyUser', result)
        }),
        getCompany: builder.query({
            query: (id) => `company/${id}`,
            providesTags: (result, error, id) => [{ type: 'Company', id }]
        }),
        currentCompany: builder.query({
            query: () => `company/current-company`,
            providesTags: ["CurrentCompany"]
        }),
        createCompany: builder.mutation({
            query: (data) => ({
                url: 'company/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'Company', id: 'LIST' }]
        }),
        inviteCompanyAccount: builder.mutation({
            query: (data) => ({
                url: 'company/user/invite',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'CompanyUser', id: 'LIST' }]
        }),
        updateCompany: builder.mutation({
            query: ({id, ...data}) => ({
                url: `company/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getCompany'),
            invalidatesTags: (result, error, { id }) => [{ type: 'Company', id }]
        }),
        validateCompanyInviteToken: builder.query({
            query: ({token}) => ({
                url: `/company/invitation/validate`,
                method: 'GET',
                params: { token }
            })
        }),
        confirmCompanyInvite: builder.mutation({
            query: ({token, accept}) => ({
                url: `/company/invitation/confirm`,
                method: 'GET',
                params: { token, accept }
            }),
            invalidatesTags: [{ type: 'Company', id: 'LIST' }]
        }),
        switchCompany: builder.mutation({
            query: ({id}) => ({
                url: `company/switch-company/${id}`,
                method: 'GET'
            })
        }),
        getCompanyAccount: builder.query({
            query: (id) => `company/users/${id}`,
            providesTags: (result, error, id) => [{ type: 'CompanyUser', id }]
        }),
        updateCompanyAccount: builder.mutation({
            query: ({id, ...data}) => ({
                url: `company/users/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getCompanyAccount'),
            invalidatesTags: (result, error, { id }) => [{ type: 'CompanyUser', id }]
        })
    })
});

export const {
    useGetCompanyQuery,
    useCreateCompanyMutation,
    useListCompaniesQuery,
    useUpdateCompanyMutation,
    useSwitchCompanyMutation,
    useCurrentCompanyQuery,
    useLazyCurrentCompanyQuery,
    useListCompanyAccountsQuery,
    useInviteCompanyAccountMutation,
    useValidateCompanyInviteTokenQuery,
    useConfirmCompanyInviteMutation,
    useGetCompanyAccountQuery,
    useUpdateCompanyAccountMutation
} = companiesApi;
